import {DomainAncestor, entityConfig} from "../../../core/common/domain/DomainAncestor";
import {observable} from "mobx";
import {ID} from "../../../core/metamodel/metaConstant";
import {SubCriterion} from "./subCriterionDomain";

@entityConfig()
export class Criterion extends DomainAncestor {

  @observable criterionId: number;
  @observable code: string;
  @observable name: string;
  @observable description: string;
  @observable subCriteria : SubCriterion[];
  @observable copyable : boolean;
  @observable criterionType : CRITERIONTYPE;
  @observable type : string;
  @observable link : string;

  constructor(json: any) {
    super(json);
  }

  public getId(): ID {
    return this.criterionId;
  }

  public setId(id: ID): void {
    this.criterionId = <number>id;
  }
}

export enum CRITERIONTYPE {
  SIMPLE = 'SIMPLE',
  COMPLEX = 'COMPLEX'
}



// WEBPACK FOOTER //
// ./src/sbtool/domain/criterion/criterionDomain.ts